<template>
  <div class="chat-container">
   
    <!-- 只有在聊天列表加载完成且有数据时才显示完整页面 -->
    <div class="content">
          <mycard class="sidebar"></mycard>
      <div class="msglist">
        <search @search-change="handleSearchChange"></search>
        <chatlist @session-change="handleSessionChange" @chatlist-loaded="handleChatlistLoaded" ref="chatlist"></chatlist>
      </div>
      <div class="chatbox">
        <message :sessionId="currentSessionId" :sessionName="currentSessionName" ref="message"></message>
        <v-text :sessionId="currentSessionId" @message-sent="handleMessageSent"></v-text>
      </div>
    </div>
  </div>
</template>
<script>
  
import search from '../../components/search/search'
import chatlist from '../../components/chatlist/chatlist'
import message from '../../components/message/message'
import vText from '../../components/text/text'
import { getRequestParams,decodeFromBase64 } from '@/utils/getPrams.js';
import api from '../../api/api'
import { MessageBox } from 'element-ui'
export default {
  components: {
    search,
    chatlist,
    message,
    vText,
    // 注册mycard组件
    mycard: () => import('../../components/mycard/mycard.vue')
  },
 
  data() {
    return {
      authObj: null,
      currentSessionId: null,
      currentSessionName: '', // 新增：当前会话名称
      showConfirmInput: false,
      isChatlistLoaded: false, // 新增：聊天列表是否加载完成
      hasChatlistData: false, // 新增：是否有聊天列表数据
      inactivityTimer: null, // 新增：无操作定时器实例
      inactivityTimeout: 600000, // 新增：10分钟超时时间（单位：ms）
      isManuallyResumingPolling: false // 新增：标志位，区分手动恢复轮询还是页面可见性变化导致的轮询恢复
    }
  },
  created() {
    // 根据URL参数判断是否显示ConfirmInput
    const urlParams = getRequestParams();
    //console.log('chat.vue - URL参数:', urlParams);
    if (urlParams) {
      // 使用浏览器兼容的Base64解码方式
      try {
        // 先解码URL编码的参数，然后再进行Base64解码
        const decodedStr = decodeFromBase64(decodeURIComponent(urlParams));
        this.authObj = decodedStr;
        //console.log('chat.vue - authObj:', this.authObj);

        if (this.authObj) {
          this.currentSessionId = this.authObj.robotId;
          // 验证token有效性
          if (this.authObj.token && this.authObj.token !== 'null' && this.authObj.type == 2) {
            // this.validateToken(this.authObj.token);
          } else {
            // 没有token，跳转到登录页面
            // 但不要传递参数，避免路由守卫再次跳转回chat页面
            this.$router.push({
              path: '/login'
            });
          }
        } else {
          // authObj解析失败，跳转到登录页面
          this.$router.push({
            path: '/login'
          });
        }
      } catch (error) {
        console.error('解析URL参数错误:', error);
        // 解析错误，跳转到登录页面
        this.$router.push({
          path: '/login'
        });
      }
    } else {
      // 没有URL参数，检查是否有本地token
      const token = localStorage.getItem('sx-token');
      if (!token) {
        // 没有本地token，跳转到登录页面
        this.$router.push('/login');
      }
    }
  },
  mounted() {
    // 初始化时设置加载状态为false
    this.isChatlistLoaded = false;
    this.hasChatlistData = false;
    
    // 添加页面可见性变化事件监听器
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    
    // 初始化无操作定时器
    this.resetInactivityTimer();
    
    // 注册用户交互事件监听器
    const userEvents = ['click', 'keydown', 'mousemove', 'scroll'];
    userEvents.forEach(event => {
      document.addEventListener(event, this.resetInactivityTimer);
    });
  },
  beforeDestroy() {
    // 移除页面可见性变化事件监听器
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    
    // 清理无操作定时器
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
    
    // 移除用户交互事件监听器
    const userEvents = ['click', 'keydown', 'mousemove', 'scroll'];
    userEvents.forEach(event => {
      document.removeEventListener(event, this.resetInactivityTimer);
    });
  },
  methods: {

    handleSessionChange(id, sessionName) {
      this.currentSessionId = id
      this.currentSessionName = sessionName
    },
    handleMessageSent(id) {
      // 通知message组件更新消息列表
      if (this.$refs.message) {
        this.$refs.message.updateMessages()
      }
    },
    handleSearchChange(searchText) {
      // 将搜索事件传递给chatlist组件
      this.$emit('search-change', searchText)
    },

    handleConfirm(value) {
      // 处理确认事件
      //console.log('确认输入的值:', value)

      // 可以在这里添加其他逻辑，比如发送消息等
    },
    // 页面可见性变化处理
    handleVisibilityChange() {
      if (document.hidden) {
        // 页面隐藏时暂停所有轮询
        this.pauseAllPolling();
      } else {
        // 页面重新可见时，如果不是手动恢复轮询才弹出确认框
        if (!this.isManuallyResumingPolling) {
          this.confirmResumePolling();
        }
      }
    },
    // 暂停所有轮询
    pauseAllPolling() {
      // 暂停聊天列表轮询
      if (this.$refs.chatlist) {
        this.$refs.chatlist.stopChatlistPolling();
      }
      // 暂停消息轮询
      if (this.$refs.message) {
        this.$refs.message.stopMessagePolling();
      }
    },
    // 弹出确认框，询问是否重新开始轮询
    confirmResumePolling() {
      MessageBox.confirm('已断开连接,是否重新连接？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
        closeOnClickModal: false // 点击空白处不关闭弹窗
      }).then(() => {
        // 用户点击确定，重新开始轮询
        this.resumeAllPolling();
      }).catch(() => {
        // 用户点击取消，确保轮询保持暂停状态
        //console.log('用户取消了重新开始轮询');
        this.pauseAllPolling();
      });
    },
    handleCancel() {
      // 处理取消事件
      //console.log('取消输入')
    },

    // 监听chatlist组件的chatlist-loaded事件
    handleChatlistLoaded(hasData) {
      this.isChatlistLoaded = true;
      this.hasChatlistData = hasData;
      if (hasData && this.$refs.chatlist) {
        this.currentSessionId = this.$refs.chatlist.selectId;
      }
    },
    // 重置无操作定时器
    resetInactivityTimer() {
      // 清除旧定时器
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
      // 创建新定时器
      this.inactivityTimer = setTimeout(() => {
        this.handleInactivityTimeout();
      }, this.inactivityTimeout);
    },
    // 重新开始所有轮询
    resumeAllPolling() {
      // 设置手动恢复轮询标志位
      this.isManuallyResumingPolling = true;
      
      // 重新开始聊天列表轮询
      if (this.$refs.chatlist) {
        this.$refs.chatlist.startChatlistPolling();
      }
      // 重新开始消息轮询
      if (this.$refs.message) {
        this.$refs.message.startMessagePolling();
      }
      
      // 延迟1000ms重置标志位，确保有足够时间处理页面可见性变化事件，防止重复弹窗
      setTimeout(() => {
        this.isManuallyResumingPolling = false;
      }, 1000);
    },
    // 处理无操作超时
    handleInactivityTimeout() {
      // 暂停所有轮询
      this.pauseAllPolling();
      // 弹出确认框提醒用户
      MessageBox.confirm('长时间未操作，断开连接。是否重新连接？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
        closeOnClickModal: false // 点击空白处不关闭弹窗
      }).then(() => {
        // 用户点击确定，重新开始轮询并重置定时器
        this.resumeAllPolling();
        this.resetInactivityTimer();
      }).catch(() => {
        // 用户点击取消，确保轮询保持暂停状态
        //console.log('用户取消了重新开始接收消息');
        this.pauseAllPolling();
      });
    },

    // 验证token有效性
    validateToken(token) {
      api.getAuthStatus({ token: token })
        .then(response => {
          if (response && response.code !== 200) {
            // Token无效，跳转到登录页面，不携带参数避免循环
            console.error('Token验证失败:', response.message);
            this.$router.push({
              path: '/login'
            });
          } else {
            //console.log('Token验证通过');
          }
        })
        .catch(error => {
          // API调用失败，也认为token无效，跳转到登录页面不携带参数
          console.error('Token验证API调用失败:', error);
          this.$router.push({
            path: '/login'
          });
        });
    }
  }
}
</script>

<style lang="less" scoped>
  .sidebar {
    width: 60px;
    height: 610px;
    // background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
    // border-right: 1px solid #dee2e6;
    transition: all 0.3s ease;
  }
  .chat-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
  
  /* 添加柔和的背景光效，与login页面一致 */
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 800px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 70%);
    transform: translate(-50%, -50%);
    z-index: 0;
  }
  
  /* 确保内容在最上层 */
  > * {
    position: relative;
    z-index: 1;
  }
}
.content {
  display: flex;
  width: 860px;
 
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;

  .msglist {
    width: 280px;
    background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
    border-right: 1px solid #dee2e6;
    transition: all 0.3s ease;
  }

  .chatbox {
    flex: 1;
    background: white;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

.loading-text {
  animation: pulse 1.5s infinite;
}

.empty-text {
  color: #999;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}
</style>
